/// <amd-module name="Repos/Editor/Components/BinaryViewer" />
import * as React from "react";
import { IBinaryDiffViewerProps, IBinaryViewerProps } from "Repos/Common/Contracts/Editor";
import * as Resources from "Repos/Editor/Resources";
import { format } from "VSS/Core/Util/String";
import { Components } from "VSS/Platform/Layout";
import { IButtonProps } from "VSSUI/Button";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { MessageCard } from "VSSUI/MessageCard";

export class BinaryViewer extends React.Component<IBinaryViewerProps> {
    public render() {
        const buttons: IButtonProps[] = [];

        if (this.props.getDownloadUrl) {
            const downloadUrl = this.props.getDownloadUrl();
            buttons.push({
                href: downloadUrl,
                text: Resources.Download
            });
        }

        return this.props.onlyIncludeContent ? (
            <MessageBar buttonProps={buttons} severity={MessageBarSeverity.Info}>
                {format(Resources.BinaryFileMessageFormat, this.props.content.metadata.extension)}
            </MessageBar>
        ) : (
            <MessageCard className="flex-grow" buttonProps={buttons}>
                {format(Resources.BinaryFileMessageFormat, this.props.content.metadata.extension)}
            </MessageCard>
        );
    }

    public componentDidMount() {
        this.props.onLoaded && this.props.onLoaded();
    }
}

Components.add("repos-binary-viewer", BinaryViewer);

export class BinaryDiffViewer extends React.Component<IBinaryDiffViewerProps> {
    public render() {
        const buttons: IButtonProps[] = [];
        let message: string;

        if (this.props.originalContent.objectId === this.props.modifiedContent.objectId) {
            if (this.props.getModifiedDownloadUrl) {
                const downloadUrl = this.props.getModifiedDownloadUrl();
                buttons.push({
                    href: downloadUrl,
                    text: Resources.Download
                });
            }
            message = Resources.BinaryIdenticalMessageFormat;
        } else {
            if (this.props.getOriginalDownloadUrl) {
                const downloadUrl = this.props.getOriginalDownloadUrl();
                buttons.push({
                    href: downloadUrl,
                    text: Resources.DownloadOriginal
                });
            }
            if (this.props.getModifiedDownloadUrl) {
                const downloadUrl = this.props.getModifiedDownloadUrl();
                buttons.push({
                    href: downloadUrl,
                    text: Resources.DownloadModified
                });
            }
            message = Resources.BinaryDifferentMessageFormat;
        }

        return this.props.onlyIncludeContent ? (
            <MessageBar buttonProps={buttons} severity={MessageBarSeverity.Info}>
                {message}
            </MessageBar>
        ) : (
            <MessageCard className="flex-grow" buttonProps={buttons}>
                {message}
            </MessageCard>
        );
    }

    public componentDidMount() {
        this.props.onLoaded && this.props.onLoaded();
    }
}

Components.add("repos-binary-diff-viewer", BinaryDiffViewer);
